import { Box, Button, Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { getI18n } from 'react-i18next';
import { FaShippingFast } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { fontWeights } from '../../../global/Fonts';
import useAssignNextTaskMutation from '../../../hooks/mutations/useAssignNextTaskMutation';
import { Card } from '../../../layout/Card';

export const OpenTasksCard = (props: {
  isAllowed: boolean;
  label: string;
  value?: number;
  fastlane: number;
  type: string;
  isLoading: boolean;
  pagePathMapping: {
    [type: string]: string;
  };
}) => {
  const { label, type, value = 0, pagePathMapping, fastlane, isLoading, isAllowed } = props;
  const pagePath = pagePathMapping[type];
  const navigate = useNavigate();
  const assignNextTaskMutation = useAssignNextTaskMutation(type);
  const { t } = getI18n();

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClick = () => {
    if (isButtonDisabled) return;

    setIsButtonDisabled(true);

    assignNextTaskMutation.mutate(
      //@ts-ignore
      {},
      {
        onSuccess: (data: any) => {
          if (data?.finished === true) {
            navigate(`/app/op/break`);
          } else if (type === 'b2c_verification' || type === 'b2c_service_history_request') {
            navigate(`/app/op/${pagePath}/${data.subject.id}/${type}`);
          } else {
            navigate(`/app/op/${pagePath}/${data.subject.id}/${type}`); //DETAILS :/${type} this when used on verifications, it shows the old verification system
          }
          setIsButtonDisabled(false);
        },
        onError: () => {
          setIsButtonDisabled(false);
        },
      },
    );
  };

  return (
    <Card borderRadius="lg" boxShadow={'lg'} flex={1} minH="15rem" p={{ base: 4, lg: 5 }} w={'full'} data-test-id={`${type}_card`}>
      <Grid
        h={'full'}
        templateAreas={`"card-header"
                  "card-content"
                  "card-fastlane"
                  "card-footer"`}
        templateRows={'20% 1fr 1fr 25%'}
      >
        <GridItem area={'card-header'} as={Grid} justifyContent={'center'}>
          {/*@ts-ignore*/}
          <Heading size={'xmd'} fontWeight={fontWeights.normal} display={'block'} textAlign={'center'}>
            {label}
          </Heading>
        </GridItem>
        <GridItem area={'card-content'} placeItems={'center'} as={Grid}>
          <Text as={'span'} fontSize="6xl" fontWeight={fontWeights.bold}>
            {value}
          </Text>
        </GridItem>
        <Flex justifyContent={'center'} alignItems={'center'}>
          <GridItem area={'card-fastlane'} placeItems={'center'} as={Grid} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box
              as={FaShippingFast}
              boxSize={7}
              mr={4}
              sx={
                fastlane && fastlane > 0
                  ? {
                      '@keyframes pulseRed': {
                        '0%': { color: 'red' },
                        '50%': { color: 'transparent' },
                        '100%': { color: 'red' },
                      },
                      animation: fastlane && fastlane > 0 && 'pulseRed 1.5s infinite',
                    }
                  : undefined
              }
            />
            <Text
              fontSize="2xl"
              fontWeight={fontWeights.bold}
              sx={
                fastlane && fastlane > 0
                  ? {
                      '@keyframes pulseRed': {
                        '0%': { color: 'red' },
                        '50%': { color: 'transparent' },
                        '100%': { color: 'red' },
                      },
                      animation: 'pulseRed 1.5s infinite',
                    }
                  : undefined
              }
            >
              {fastlane}
            </Text>
          </GridItem>
        </Flex>

        <GridItem area={'card-footer'} as={Grid} placeItems={'center'}>
          {value && value > 0 ? (
            <Button
              variant="primary"
              disabled={assignNextTaskMutation.isPending || isLoading || !isAllowed || isButtonDisabled}
              data-test-id={`${type}_assign_button`}
              onClick={handleClick}
            >
              {/*@ts-ignore*/}
              {t('common:new_activity')}
            </Button>
          ) : (
            //@ts-ignore
            <Text>{t(`common:caught_up`)}</Text>
          )}
        </GridItem>
      </Grid>
    </Card>
  );
};

export default OpenTasksCard;
